import React from 'react';


export default function Day(props) {
    function returnDateString(date) {
        const d = new Date(date)
        const Dstring = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate()
        return (Dstring)
    }
    function returnEventsOnDate(allEvents, dateString) {
        var eventsOnDate = [];
        for (let i = 0; i < allEvents.length; i++) {
            if (returnDateString(allEvents[i].start) === dateString) {
                eventsOnDate.push(allEvents[i]);
            }
        }
        return eventsOnDate;
    }
    function hasOnDate(array, dateString) {
        return array && array.find(element => returnDateString(element.start) == dateString)
    }
    function returnColorArray() {
        const arr = []
        if (hasMyVenueBookings) { arr.push('var(--wht)') }
        if (hasVenueBookings) { arr.push('var(--org)') }
        if (hasEvents) { arr.push('var(--prl)') }
        if (hasServiceBookings) { arr.push('var(--yel)') }
        return arr
    }

    const { day, setDate, sel, setSel, date, onlyActive, eventDates, venueBookDates, myvenueBookDates, serBks } = props
    const today = new Date()
    const yearP = (sel.getFullYear() < today.getFullYear())
    const monthP = (sel.getFullYear() == today.getFullYear() && sel.getMonth() < today.getMonth())
    const dateP = (sel.getFullYear() == today.getFullYear() && sel.getMonth() == today.getMonth() && today.getDate() > day)
    const dateString = sel.getFullYear() + "-" + sel.getMonth() + "-" + day
    const hasEvents = hasOnDate(eventDates, dateString)
    const hasVenueBookings = hasOnDate(venueBookDates, dateString)
    const hasMyVenueBookings = hasOnDate(myvenueBookDates, dateString)
    const hasServiceBookings = hasOnDate(serBks, dateString)
    let colorCount = 0
    //Color count
    if (hasEvents) { colorCount++ }
    if (hasVenueBookings) { colorCount++ }
    if (hasMyVenueBookings) { colorCount++ }
    if (hasServiceBookings) { colorCount++ }

    if (day === 0) {
        //this creates an empty box for the begining and the end of the month where there are no days
        return (
            <div style={{ width: 40, height: 30, }} />
        )
    }
    else if (onlyActive) {
        //this day version is used for the cases where should anly be able to click on the dates that have events on them
        if (yearP || monthP || dateP) {
            //this version of a day appears if the date is already passed, it lookes darker
            return (
                <div style={{ width: 40, height: 30, paddingBlockStart: '1px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{color: 'var(--ltg)'}}>{day}</p>
                </div>
            )
        } else if (colorCount > 0) {
            //this version appears only if there are events on that date and has different versions for different types of events 
            if (colorCount == 1) {
                return (
                    <div style={{
                        width: 40,
                        height: 30,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor:
                            hasEvents ? 'var(--prl)' :
                                hasMyVenueBookings ? 'var(--wht)' :
                                    hasVenueBookings ? 'var(--org)' :
                                        hasServiceBookings && 'var(--yel)',
                        borderRadius: 5,
                        padding: 2
                    }}
                        onClick={() => {
                            const newDate = new Date(sel.getFullYear(), sel.getMonth(), day)
                            setDate({
                                venueBookings: venueBookDates && returnEventsOnDate(venueBookDates, dateString),
                                myvenueBookings: myvenueBookDates && returnEventsOnDate(myvenueBookDates, dateString),
                                events: eventDates && returnEventsOnDate(eventDates, dateString),
                                serBks: serBks && returnEventsOnDate(serBks, dateString)
                            })
                            setSel(newDate)
                        }}>
                        <div style={{ width: "100%", display: 'flex', height: "100%", backgroundColor: 'var(--drg)', cursor: 'pointer', borderRadius: 3, alignItems: 'center', justifyContent: 'center', paddingBlockStart: 1 }}>
                            {sel.getFullYear() === today.getFullYear() && sel.getMonth() === today.getMonth() && today.getDate() === day
                                ? <p className='DayYORP'>{day}</p>
                                : <p style={{color: 'var(--wht)'}}>{day}</p>}
                        </div>
                    </div>
                )
            }
            else if (colorCount > 1) {
                return (
                    <div style={{ display: 'flex', width: 40, height: 30, justifyContent: 'center', alignItems: 'center', backgroundColor: 'var(--yel)', borderRadius: 5, padding: 2 }}
                        onClick={() => {
                            const newDate = new Date(sel.getFullYear(), sel.getMonth(), day)
                            setDate({
                                venueBookings: venueBookDates && returnEventsOnDate(venueBookDates, dateString),
                                myvenueBookings: myvenueBookDates && returnEventsOnDate(myvenueBookDates, dateString),
                                events: eventDates && returnEventsOnDate(eventDates, dateString),
                                serBks: serBks && returnEventsOnDate(serBks, dateString)
                            })
                            setSel(newDate)
                        }}>
                        <div
                            // LinearGradient
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            locations={colorCount == 2 ? [0.4, 0.6] : colorCount == 3 ? [0.2, 0.5, 0.8] : colorCount == 4 && [0.2, 0.4, 0.6, 0.8]}
                            colors={returnColorArray()}
                            style={{ position: "absolute", left: 0, right: 0, top: 0, height: 30, borderRadius: 5 }}
                        />
                        <div style={{ width: "100%", height: "100%", backgroundColor: 'var(--drg)', cursor: 'pointer', borderRadius: 3, alignItems: 'center', justifyContent: 'center', paddingBlockStart: 1 }}>
                            {sel.getFullYear() === today.getFullYear() && sel.getMonth() === today.getMonth() && today.getDate() === day
                                ? <p className='DayYORP'>{day}</p>
                                : <p style={{color: 'var(--wht)'}}>{day}</p>}
                        </div>
                    </div>
                )
            }
        } else {
            return (
                //this version of the day returns if the date is in the future but there arre no events on that day
                //you can't click on that date
                <div style={{ display: 'flex', justifyContent: 'center', width: 40, height: 30, alignItems: 'center', paddingBlockStart: 1 }}>
                    {sel.getFullYear() === today.getFullYear() && sel.getMonth() === today.getMonth() && today.getDate() === day
                        //if current day is matching todays date it will be highlighted with animation
                        ? <p className='DayYORP'>{day}</p>
                        : <p style={{color: 'var(--wht)'}}>{day}</p>}
                </div>
            )
        }
    } else {
        //this day version allows you to pick any date and doesn't display current events 
        console.log('sel:', sel, 'date:', date)
        if (sel.getFullYear() === date.getFullYear() && sel.getMonth() === date.getMonth() && date.getDate() === day) {
            return (
                <button style={{ display: 'flex', width: 40, borderWidth: 2, alignItems: 'center', justifyContent:  'center', animation: 'colorYORP 8s linear  infinite', fontSize: 16}}
                    onClick={() => {
                        const newDate = new Date(sel.getFullYear(), sel.getMonth(), day)
                        setDate(newDate)
                        setSel(newDate)
                    }}>
                    <div style={{ borderWidth: 0, width: 0, height: 0, borderRadius: 5, backgroundColor: 'var(--drg)', paddingBlockStart: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <p  style={{color: 'var(--wht)'}}>{day}</p>
                    </div>
                </button>
            )
        } else if (yearP || monthP || dateP) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 40, height: 30, paddingBlockStart: 1, }}>
                    <p style={{ color: 'var(--ltg)' }}>{day}</p>
                </div>
            )
        } else {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 40, height: 30, paddingBlockStart: 1, cursor: 'pointer' }}
                    onClick={() => {
                        const newDate = new Date(sel.getFullYear(), sel.getMonth(), day)
                        setDate(newDate)
                        setSel(newDate)
                    }}>
                    {sel.getFullYear() === today.getFullYear() && sel.getMonth() === today.getMonth() && today.getDate() === day
                        ? <p className='DayYORP'>{day}</p>
                        : <p style={{color: 'var(--wht)'}}>{day}</p>}
                </div>
            )
        }
    }
}